import useUser from "../Hooks/useUser";


//const RolHelper = () => {
    const CLAIM_CODCUSTOMER = 'CodigoCustomer';
    const CLAIM_USUARIO_ID = 'Bandicoot';
    const CLAIM_PERSONA_ID = 'Falcon';
    const CLAIM_CUSTOMER_ID = "beta";
    const CLAIM_CUENTA_ID = "alfa";
    export const keyAccess = "Access";
    const CLAIM_ROLE = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"

    const CLAIM_ROLE_ADMIN = "Admin"
    const CLAIM_ROLE_INNOVACION = "Innovacion"

    const getInfoToken= (token, tipoDato) => {
        if(!token){
        return "";
        }
            let t = JSON.parse(atob(token.split(".")[1]));
            let codigo = t[tipoDato];
            return codigo;
    };

    const getAccessLocalStorage = () => {
      let c = localStorage.getItem(keyAccess);
      if (c) {
        //console.log("c", c)
        return JSON.parse(c);
      }
    
      return null;
    };

    const validateRole = (claim) => {
      if (Array.isArray(claim)) {
        return claim;
      } else {
        if (typeof claim == "undefined" || claim == null) {
          return [];
        } else {
          let r = [claim];
  
          return r;
        }
      }
    };

    export {
  
      
          /* CLAIMS */
        
        CLAIM_CODCUSTOMER,
        CLAIM_PERSONA_ID,
        CLAIM_USUARIO_ID,
        CLAIM_CUSTOMER_ID,
        CLAIM_CUENTA_ID,
        CLAIM_ROLE,
      
        /* Validar Role */
        getInfoToken,
        getAccessLocalStorage,
        validateRole,

        CLAIM_ROLE_ADMIN,
        CLAIM_ROLE_INNOVACION
      
        /* Verificar si puede ver todo */
        /* isRoleAccessAll,
        roleAdmin, ROLE_USREXT, ROLE_AMDINCONT,ROLE_SAFETY */
      };

